<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.fullPath)">
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                <v-icon class="me-2">mdi-clock-alert-outline</v-icon>
                Late & Early Leave Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="loadReport" ref="filterForm">
                  <v-row class="py-3 px-3" align="end">
                  <v-col cols="12" sm="6" md="3">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="filters.from_date"
                      label="From Date"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar"
                      hide-details="auto"
                      required
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="filters.to_date"
                      label="To Date"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar"
                      hide-details="auto"
                      required
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                      v-model="filters.employee_id"
                      :items="employees"
                      :item-title="(item) => `${item.name} - ${item.code || item.employee_code || item.emp_id || ''}`"
                      item-value="id"
                      label="Employee (Optional)"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      hide-details="auto"
                      :loading="employeesLoading"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3" class="d-flex align-end">
                    <v-btn
                      type="submit"
                      color="primary"
                      variant="flat"
                      :loading="loading"
                      prepend-icon="mdi-magnify"
                      density="compact"
                      height="40"
                    >
                      Search
                    </v-btn>
                  </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Summary Cards -->
          <!-- <v-row v-if="reportData.length > 0" class="mb-3 pa-3">
            <v-col cols="12" sm="6" md="3">
              <v-card variant="outlined" color="primary">
                <v-card-text>
                  <div class="text-caption text-black">Total Late Count</div>
                  <div class="text-h5 text-black font-weight-bold">
                    {{ totalLateCount }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card variant="outlined" color="warning">
                <v-card-text>
                  <div class="text-caption text-black">Total Early Count</div>
                  <div class="text-h5 text-black font-weight-bold">
                    {{ totalEarlyCount }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card variant="outlined" color="error">
                <v-card-text>
                  <div class="text-caption text-black">Total Late Hours</div>
                  <div class="text-h5 text-black font-weight-bold">
                    {{ totalLateHours.toFixed(2) }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card variant="outlined" color="success">
                <v-card-text>
                  <div class="text-caption text-black">Total Working Hours</div>
                  <div class="text-h5 text-black font-weight-bold">
                    {{ totalWorkingHours.toFixed(2) }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row> -->

          <!-- Report Table -->
          <v-expansion-panels v-model="reportPanel" class="mt-3">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                expand-icon="mdi-chevron-down"
                >
                <v-icon class="me-2">mdi-table</v-icon>
                Report Data
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        v-if="reportData.length > 0"
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToExcel"
                          :disabled="!reportData.length"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          :disabled="!reportData.length"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12"></v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="filteredReportDataWithSl"
                  :loading="loading"
                  item-value="employee_code"
                  class="elevation-0 table-bordered"
                  :items-per-page="25"
                  :items-per-page-options="[10, 25, 50, 100]"
                >
                <template v-slot:item.sl="{ item }">
                  <div class="text-center">{{ item.sl }}</div>
                </template>

                <template v-slot:item.month="{ item }">
                  <span class="font-weight-medium">{{ item.month }}</span>
                </template>

                <template v-slot:item.employee_code="{ item }">
                  <div>{{ item.employee_code || '-' }}</div>
                </template>

                <template v-slot:item.employee_name="{ item }">
                  <div class="font-weight-medium">{{ item.employee_name || '-' }}</div>
                </template>

                <template v-slot:item.total_late_count="{ item }">
                  <v-chip
                    :color="item.total_late_count > 0 ? 'error' : 'success'"
                    size="small"
                    variant="text"
                  >
                    {{ item.total_late_count }}
                  </v-chip>
                </template>

                <template v-slot:item.total_early_count="{ item }">
                  <v-chip
                    :color="item.total_early_count > 0 ? 'warning' : 'success'"
                    size="small"
                    variant="text"
                  >
                    {{ item.total_early_count }}
                  </v-chip>
                </template>

                <template v-slot:item.total_late_hours="{ item }">
                  <div class="text-center">
                    <span :class="item.total_late_hours > 0 ? 'text-error font-weight-bold' : ''">
                      {{ item.total_late_hours.toFixed(2) }}
                    </span>
                  </div>
                </template>

                <template v-slot:item.total_working_hours="{ item }">
                  <div class="text-center">
                    <span class="text-success font-weight-medium">
                      {{ item.total_working_hours.toFixed(2) }}
                    </span>
                  </div>
                </template>

                <template v-slot:no-data>
                  <div class="text-center pa-8">
                    <v-icon size="64" color="grey-lighten-1">mdi-database-off</v-icon>
                    <div class="text-h6 mt-4 text-grey">No data available</div>
                    <div class="text-caption text-grey">Please select date range and click Search</div>
                  </div>
                </template>

                <template v-slot:loading>
                  <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
                </template>
              </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { toast } from 'vue3-toastify'
import { useStore } from 'vuex'
import { formatDateView, formatDateDash } from "@/plugins/helpers";


const store = useStore()
const instance = getCurrentInstance()
const appContext = instance?.appContext

// Loading states
const loading = ref(false)
const employeesLoading = ref(false)
const panel = ref([0])
const reportPanel = ref([0])
const search = ref('')

// Filters
const filters = ref({
  from_date: null,
  to_date: null,
  employee_id: null
})

// Data
const reportData = ref([])
const employees = ref([])

// Table headers
const headers = [
  { title: '# SL', key: 'sl', sortable: false, align: 'center' },
  { title: 'Month', key: 'month', sortable: false, align: 'center' },
  { title: 'Employee Code', key: 'employee_code', sortable: false, align: 'center' },
  { title: 'Employee Name', key: 'employee_name', sortable: false, align: 'center' },
  { title: 'Department', key: 'department', sortable: true, align: 'center' },
  { title: 'Designation', key: 'designation', sortable: false, align: 'center' },
  { title: 'Late Count', key: 'total_late_count', sortable: false, align: 'center' },
  { title: 'Early Count', key: 'total_early_count', sortable: false, align: 'center' },
  { title: 'Late Hours', key: 'total_late_hours', sortable: false, align: 'center' },
  { title: 'Working Hours', key: 'total_working_hours', sortable: false, align: 'center' }
]

// Computed summary
const totalLateCount = computed(() => {
  return reportData.value.reduce((sum, item) => sum + (item.total_late_count || 0), 0)
})

const totalEarlyCount = computed(() => {
  return reportData.value.reduce((sum, item) => sum + (item.total_early_count || 0), 0)
})

const totalLateHours = computed(() => {
  return reportData.value.reduce((sum, item) => sum + (item.total_late_hours || 0), 0)
})

const totalWorkingHours = computed(() => {
  return reportData.value.reduce((sum, item) => sum + (item.total_working_hours || 0), 0)
})

const formatTime = (timeStr) => {
  if (!timeStr || timeStr === '-') return '-'
  const timeParts = timeStr.split(':')
  if (timeParts.length < 2) return timeStr
  const hours = parseInt(timeParts[0], 10)
  const minutes = timeParts[1]
  if (isNaN(hours)) return timeStr
  const period = hours >= 12 ? 'PM' : 'AM'
  const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours
  return `${displayHours}:${minutes} ${period}`
}

const formatNumber = (value, fraction = 0) => {
  if (value === undefined || value === null || isNaN(value)) return '-'
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction
  })
}

// Computed for company info
const getCurrentCompany = computed(() => {
  return store.getters.getCurrentCompany || {}
})

const getFileServerUrl = computed(() => {
  return store.getters.getFileServerUrl || ''
})

// Computed data with SL numbers
const reportDataWithSl = computed(() => {
  return reportData.value.map((item, index) => ({
    ...item,
    sl: index + 1
  }))
})

// Filtered report data with SL numbers based on search
const filteredReportDataWithSl = computed(() => {
  if (!search.value) {
    return reportDataWithSl.value
  }
  
  const searchLower = search.value.toLowerCase()
  return reportDataWithSl.value.filter(item => {
    const employeeCode = (item.employee_code || '').toLowerCase()
    const employeeName = (item.employee_name || '').toLowerCase()
    const month = (item.month || '').toLowerCase()
    return employeeCode.includes(searchLower) || 
           employeeName.includes(searchLower) || 
           month.includes(searchLower)
  })
})

// Methods
const loadEmployees = async () => {
  employeesLoading.value = true
  try {
    const response = await store.dispatch('getEmployees')
    if (response.data.success && response.data.data) {
      employees.value = response.data.data
    } else if (response.data.data) {
      employees.value = response.data.data
    } else {
      employees.value = []
    }
  } catch (error) {
    employees.value = []
    console.error('Error loading employees:', error)
  } finally {
    employeesLoading.value = false
  }
}

const loadReport = async () => {
  if (!filters.value.from_date || !filters.value.to_date) {
    toast.error('Please select both From Date and To Date')
    return
  }

  loading.value = true
  try {
    const params = {
      from_date: formatDateDash(filters.value.from_date),
      to_date: formatDateDash(filters.value.to_date)
    }

    if (filters.value.employee_id) {
      params.employee_id = filters.value.employee_id
    }

    const response = await store.dispatch('getLateEarlyReport', params)

    if (response.success) {
      reportData.value = response.data || []
      if (reportData.value.length === 0) {
        toast.info('No data found for the selected criteria')
      }
    } else {
      toast.error(response.message || 'Failed to load report')
      reportData.value = []
    }
  } catch (error) {
    toast.error(error.response?.data?.message || error.message || 'Failed to load report')
    reportData.value = []
  } finally {
    loading.value = false
  }
}

const resetFilters = () => {
  const today = new Date()
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)

  filters.value = {
    from_date: firstDay,
    to_date: lastDay,
    employee_id: null
  }
  reportData.value = []
}

// Export to Excel
const exportToExcel = () => {
  if (!reportData.value.length) {
    toast.warning('No data to export')
    return
  }



  const data = [
    ['Late & Early Leave Report'],
    [`From Date: ${formatDateView(formatDateDash(filters.value.from_date))} to ${formatDateView(formatDateDash(filters.value.to_date))}`]
  ]
  
  if (filters.value.employee_id) {
    const selectedEmployee = employees.value.find(e => e.id === filters.value.employee_id)
    if (selectedEmployee) {
      data.push([`Employee: ${selectedEmployee.name || ''}${selectedEmployee.employee_code || selectedEmployee.code || selectedEmployee.emp_id ? ` (${selectedEmployee.employee_code || selectedEmployee.code || selectedEmployee.emp_id})` : ''}`])
    }
  }
  
  data.push([], ['# SL', 'Month', 'Employee Code', 'Employee Name', 'Department', 'Designation', 'Late Count', 'Early Count', 'Late Hours', 'Working Hours'], [])

  // Add data rows
  reportData.value.forEach((row, index) => {
    data.push([
      index + 1,
      row.month || '-',
      row.employee_code || '-',
      row.employee_name || '-',
      row.department || '-',
      row.designation || '-',
      formatNumber(row.total_late_count),
      formatNumber(row.total_early_count),
      formatNumber(row.total_late_hours, 2),
      formatNumber(row.total_working_hours, 2)
    ])
  })

  const proxy = appContext?.config?.globalProperties
  if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
    proxy.$exportTableToExcel(data, 'late_early_report_' + proxy.$fileDate())
  }
}

// Export to PDF
const exportToPDF = async () => {
  if (!reportData.value.length) {
    toast.warning('No data to export')
    return
  }



  const company = getCurrentCompany.value
  const fileServerUrl = getFileServerUrl.value
  const selectedEmployee = filters.value.employee_id 
    ? employees.value.find(e => e.id === filters.value.employee_id)
    : null

  let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`)
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta http-equiv="X-UA-Compatible" content="ie=edge">
        <title>Late & Early Leave Report</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
        <style>
          body { font-family: 'Arimo', sans-serif; margin: 0px; }
          .invoice-header { display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #eee; padding-bottom:10px; }
          .invoice-header img { max-height: 70px; max-width: 150px; }
          .table th, .table td { border: 1px solid #000; padding: 8px; vertical-align: middle; font-size: 12px; }
          .table th { background-color: #f0f0f0; color: #333; }
          .text-end { text-align: right; }
          .text-center { text-align: center; }
          h4 { font-size: 20px; color: #333; }
          p { font-size: 14px; color: #555; margin: 2px 0; }
          strong { font-weight: bold; color: #333; }
          @page { margin: 0.5in; size: letter; }
          .logo-container { display:flex; align-items:center; }
          .logo-container img { margin-left: 10px; }
          .table { width: 100%; border-collapse: collapse; table-layout: auto; }
          thead { display: table-header-group; }
        </style>
      </head>
      <body>
        <div class="container-fluid position-relative">
          <div class="invoice-header">
            <div>
              <h4 class="text-uppercase">${company?.name || 'Company Name'}</h4>
              <p style="width:65%">${company?.address || ''}</p>
              <p><i class="mdi mdi-phone-outline"></i> ${company?.mobile || ''}</p>
              <p><i class="mdi mdi-email-outline"></i> ${company?.email || ''}</p>
              ${company?.website ? `<p><i class="mdi mdi-web"></i> ${company.website}</p>` : ''}
            </div>
            <div class="logo-container">
              ${company?.logo_thumb ? `<img src="${fileServerUrl}${company.logo_thumb}" alt="Logo" class="img-fluid">` : ''}
            </div>
          </div>
          <h4 class="text-center my-4"><strong>LATE & EARLY LEAVE REPORT</strong></h4>
          <div class="row mb-3">
            <div class="col-sm-8">
              <p><strong>Period:</strong> ${formatDateView(formatDateDash(filters.value.from_date))} to ${formatDateView(formatDateDash(filters.value.to_date))}</p>
              ${selectedEmployee ? `<p><strong>Employee:</strong> ${selectedEmployee.name || ''} ${selectedEmployee.employee_code || selectedEmployee.code || selectedEmployee.emp_id ? `(${selectedEmployee.employee_code || selectedEmployee.code || selectedEmployee.emp_id})` : ''}</p>` : ''}
            </div>
            <div class="col-sm-4 text-end">
              <p><strong>Total Records:</strong> ${reportData.value.length}</p>
            </div>
          </div>
          <table class="table mt-4">
            <thead>
              <tr>
                <th>SN</th>
                <th>Month</th>
                <th>Employee Code</th>
                <th>Employee Name</th>
                <th>Department</th>
                <th>Designation</th>
                <th class="text-center">Late Count</th>
                <th class="text-center">Early Count</th>
                <th class="text-center">Late Hours</th>
                <th class="text-center">Working Hours</th>
              </tr>
            </thead>
            <tbody>
              ${reportData.value.map((row, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${row.month || '-'}</td>
                  <td>${row.employee_code || '-'}</td>
                  <td><strong>${row.employee_name || '-'}</strong></td>
                  <td>${row.department || '-'}</td>
                  <td>${row.designation || '-'}</td>
                  <td class="text-center">${formatNumber(row.total_late_count)}</td>
                  <td class="text-center">${formatNumber(row.total_early_count)}</td>
                  <td class="text-center">${formatNumber(row.total_late_hours, 2)}</td>
                  <td class="text-center">${formatNumber(row.total_working_hours, 2)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      </body>
    </html>
  `)
  printWindow.moveTo(0, 0)
  printWindow.focus()
  await new Promise(resolve => setTimeout(resolve, 500))
  printWindow.print()
  printWindow.close()
}

// Initialize
onMounted(async () => {
  await loadEmployees()
  resetFilters()
})
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
}

.table-bordered :deep(th),
.table-bordered :deep(td) {
  border: 1px solid #000000 !important;
}

.table-bordered :deep(table) {
  border-collapse: collapse;
}

.gap-2 {
  gap: 8px;
}

.panel-header {
  font-weight: 600;
}
</style>

